export default class AreaEditWishlistListing {
    constructor(node) {
        this.node = node;

        this.addListeners();
    }
    
    addListeners() {
        this.node.querySelectorAll('.wishlist-header').forEach(function(wishlistHeader) {
            wishlistHeader.addEventListener('click', function(event) {
                this.parentNode.classList.toggle('is-open', !this.parentNode.classList.contains('is-open'));
                $(this.parentNode.querySelector('.wishlist-products')).slideToggle();
            });
        });
    }

    static init() {
        let listingWishlist = document.querySelector("[data-listing-wishlist]");

        if (listingWishlist) {
            return new AreaEditWishlistListing(listingWishlist);
        }
    }
}